<template>
  <div>
    

    <!-- Gallery Coming Soon -->
    <div id="gallery" class="uk-container uk-margin-large-top uk-animation-fade">   
        <!-- cool wave loading animation -->
        <div>
          <h4 class="uk-text-center" style="margin-top: 8vh"><i class="material-icons uk-inline wm-green1">build</i>&nbsp;Coming soon...</h4>
          <div class="box centered">                    
            <div v-for="n in 550" :key="n" class="circle"></div>
          </div>          
        </div>
          
    </div>

    <!-- Gallery -->
    <div v-show="0" class="this_is_actual_gallery">
      <!-- Search Bar -->
        <div class="body-navbar" uk-sticky="offset: 56;">
          <div class="uk-container">
            <div class="uk-animation-slide-top-small uk-animation-fast">  
              <div class="uk-grid uk-flex-center">
                <div>
                  <form class="boundary-align uk-search uk-search-default" style="width: 50vw; margin-top: 12px; margin-bottom: 12px;">
                      <a href="" uk-search-icon></a>
                      <input class="uk-search-input search-bling" v-model="search" type="search" placeholder="Search Album Name...">                  
                  </form>
                  <div uk-dropdown="pos: bottom-justify; boundary: .boundary-align; boundary-align: true; mode: click; offset: -10" class="search-dropdown">
                    <ul class="uk-list">
                      <li v-for="album in filteredAlbums" :key="album.id" class="uk-margin-remove search-dropdown-row"> 
                        <div uk-grid>
                          <div class="uk-width-expand"><i class="material-icons uk-inline wm-blue">photo_album</i> {{album.albumName}}</div>
                          <div class="uk-text-small uk-text-muted">{{album.createdOn}}</div>
                        </div>                                                                 
                      </li>
                    </ul>
                  </div>
                </div>
              <div>
                <a @click="scrollToTop" class="uk-icon-button uk-icon" uk-tooltip="title: To Top; pos: bottom" style="text-decoration: none;  margin-top: 14px; float: right;">
                  <i class="material-icons">keyboard_arrow_up</i>
                </a>    
              </div>  
              <div>
                <a @click="loadAlbums" class="uk-icon-button uk-icon" uk-tooltip="title: Refresh; pos: bottom" style="text-decoration: none;  margin-top: 14px; float: right;">
                  <i class="material-icons">refresh</i>
                </a>    
              </div>                          
              </div>                       
            </div>
          </div>         
  
        </div>   
      <!-- Gallery Loading -->
      <div v-show="globalSessionInfo.isLoading.gallery" class="uk-margin-top uk-text-center">
        <div class="uk-margin-bottom">Loading...</div>
        <span class="wm-green2"><div uk-spinner></div></span>
        <!-- cool wave loading animation -->
        <div class="box centered">        
          <div v-for="n in 550" :key="n" class="circle"></div>
        </div>
      </div> 
      <!-- Gallery -->
      <div id="gallery" :class="['uk-container', 'uk-margin-top', 'uk-animation-fast',  {'vue-hidden': globalSessionInfo.isLoading.gallery, 'uk-animation-fade': globalSessionInfo.isLoading.gallery == false}]">        
        <div v-for="(album, index) in albums" :key="album.id" class="albums">
          <!-- Album -->
          <div>
            <!-- <div class="album-header" uk-sticky="offset: 128; bottom: true;" style="z-index: 2;"> this is so hard to get to work with all the other js controlled dom elements :( -->
            <div class="album-header" style="z-index: 2;">
              <div class="uk-grid" >
                <!-- Album Title -->
                <div class="uk-width-expand" style="margin-bottom: 8px;"><i class="material-icons uk-inline wm-blue">photo_album</i> <b> {{album.albumName}}</b>  &middot;  <span class="uk-text-small">{{album.images.length}} images </span> </div>
                <div class="uk-margin-right">{{album.createdOn}}</div> 
                <a class="uk-padding-remove uk-margin-remove"><i class="material-icons uk-text-muted">more_vert</i> </a>
                    <div uk-dropdown="pos: bottom-right" class="uk-padding-remove uk-margin-remove">
                      <div class="uk-text-small" style="min-height: 30px;">   
                          <ul class="dropdown-list">
                            <li @click="renameAlbum(album, index)" class="drop-list-item"><i class="material-icons uk-inline uk-text-muted">create</i> Rename</li>
                            <li class="drop-list-item"><i class="material-icons uk-inline uk-text-muted">delete_outline</i> Delete Album</li>
                          </ul>
                      </div>
                    </div>                                         
              </div>
            </div>
            <div class="image-container">          
              <div :id="'lightgallery_' + index" class="fj-gallery">
                <a v-for="image in album.images" :key="image.id" :href="image" class="fj-gallery-item">
                  <img :src="image"/>          
                </a>
              </div>          
            </div>
          </div>
          <hr class="hr-fade">
        </div>      
      </div>
      <div class="uk-text-center uk-margin-bottom uk-animation-fade">       
        Refresh albums <span><a @click="loadAlbums" class="uk-icon-button uk-icon" style="text-decoration: none;" uk-tooltip="title: Refresh; pos: bottom"><i class="material-icons">refresh</i></a></span>        
      </div>    
    </div>
  </div>

    <!-- Offcanvas Album Activity -->
    <!--
    <div id="offcanvas-album-activity" class="uk-light" uk-offcanvas="flip: true">
        <div class="uk-offcanvas-bar uk-light">
            <button class="uk-offcanvas-close" type="button" uk-close></button>

            <legend class="uk-legend"><i class="material-icons uk-inline">photo_library</i> Demo Album 1  &middot;  <span class="uk-text-small uk-text-muted">{{images.length}} images</span> &middot; <span class="uk-text-small uk-text-muted">12/07/2018</span></legend>
            <hr>

            <timeline-gallery v-for="item in timeline" v-bind:key="item.id" :item="item"></timeline-gallery>          
            <ul uk-accordion="multiple: true">
                <li class="uk-open">
                  <a class="uk-accordion-title uk-text-muted" href="#">Your Mark</a>
                  <div class="uk-accordion-content">
                      <p>This watermark will be saved to My Marks and can be used in the Apply mode. </p>
                  </div>
                  <hr>
                </li>
            </ul>
        </div>
    </div>
    -->
</template>

<script>
import Vue from 'vue'

import SidebarGallery from './SidebarGallery.vue'
import TimelineGallery from './TimelineGallery.vue'

import firebase from 'firebase/app'
import imagesLoaded from 'imagesloaded'

import 'lightgallery.js';
import 'lg-thumbnail.js';
import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-hash.js';

  export default {
    name: 'Gallery',
    components: {
    'sidebar-gallery': SidebarGallery,
    'timeline-gallery': TimelineGallery
    },    
    data () {
      return {
        albums: [],
        search: '',
        visitedGallery: false

    /*
            timeline: [
                {
                    id: 4,
                    imageName: 'Beautiful Image',
                    imageLiked: true,
                    imageComment: 'Love it!',
                    changedOn: '24. Sep 14:48',
                    feedbackFrom: ['Sarah Lee']
                },
            ],

        images: [
          'https://images.unsplash.com/photo-1550612159-5730f34e4fc0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550658511-1ed05e6ac16c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550745165-9bc0b252726f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550746566-eed1e3bc3a3b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550742101-a492319db3f5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550720590-0963d5d0d031?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550719888-ffef4f5b476e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550647512-8b8a24d4f646?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550726570-5d88e3969025?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550664255-94d114340500?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550593802-08de396435da?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550622349-3e3b7a29d6ec?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550719888-ffef4f5b476e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',        
          'https://images.unsplash.com/photo-1550612159-5730f34e4fc0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550658511-1ed05e6ac16c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550745165-9bc0b252726f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550746566-eed1e3bc3a3b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550742101-a492319db3f5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550720590-0963d5d0d031?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550719888-ffef4f5b476e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550647512-8b8a24d4f646?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550726570-5d88e3969025?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550664255-94d114340500?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550593802-08de396435da?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550622349-3e3b7a29d6ec?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
          'https://images.unsplash.com/photo-1550719888-ffef4f5b476e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60'        
          ]
          */

      }
    },
    methods: {    
      scrollToTop() {
          window.scrollTo(0,0);
      },
      loadAlbums() { 
        
        Vue.set(me.globalSessionInfo.isLoading, 'gallery', true)        
        
        // 1.) Pull all album data + urls
        let me;
        me = this;
          // Watch changes in watermarks
          const userId = me.globalSessionInfo.currentUser.userId
          const albumsRef = firebase.firestore().collection('gallery').doc(userId).collection('albums')  

            me.albums = []
            albumsRef.get().then(function (querySnapshot) {              
              querySnapshot.forEach(function (doc) {
                me.albums.push(doc.data())
              });
              
              // re-order albums by createdOn desc
              me.albums = _.orderBy(me.albums, 'createdOnPrecise').reverse()
              me.renderAlbums()  
            })
      },
      renderAlbums() {
        var me;
        me = this;
        imagesLoaded('#gallery', function() {                
          setTimeout(function(){       
            fjGallery(document.querySelectorAll('.fj-gallery'), {
                itemSelector: '.fj-gallery-item',
                rowHeight: 180,
                onJustify: enableLightGallery()
            });  
          }, 100);
        });          
    
        function enableLightGallery() {
          setTimeout(function(){   
          Vue.set(me.globalSessionInfo.isLoading, 'gallery', false)  
          
            // using lightgallery hash to create gallery per album
            for (let i = 0; i < me.albums.length; i++) {
              var lightGalleryId = 'lightgallery_' + i;
              lightGallery(document.getElementById(lightGalleryId), {
                  thumbnail: false,
                  animateThumb: true,
                  progressBar: true,
                  zoom: true,
                  mousewheel: true,
                  hash: true,
                  galleryId: i
              });  
            }          
          }, 1000);

        }
      },
      renameAlbum(album, index) {
        var me;
        me = this;

        const userId = this.globalSessionInfo.currentUser.userId
        const albumRef = firebase.firestore().collection('gallery').doc(userId).collection('albums').doc(album.documentId)

        UIkit.modal.prompt('New Album Name:', '').then(function (name) {
          albumRef.update({
              albumName: name
          })
          .then(function() {
            me.albums[index].albumName = name;
          })
        });

      }    
    },
    computed: {
      filteredAlbums() {
        return this.albums.filter(album => {
          return album.albumName.toLowerCase().includes(this.search.toLowerCase()) || album.albumName.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    },
    created() {            
      
    },
    mounted() {
      /* Commenting out while Gallery is in "Coming Soon" mode
      // start data load       
      if (this.visitedGallery != true) {
        // this works becuase vue routes are <keep-alive> so data and cache is kept in memory!
        this.visitedGallery = true;
        this.loadAlbums();      
      }      
      */
    }   
  }
</script>

<style scoped>
  .vue-hidden {
    visibility: hidden;
  }

  .uk-offcanvas-bar {
    width: 40vw;
  }

  .uk-link-text {
    text-decoration: none;
  }

  .search-bling {
    background: rgb(255, 255, 255) !important;
    border-radius: 8px;
    height: 38px;
    border: none !important;
  }

  .search-bling:focus, select {
    box-shadow: 0 1px 2px 0 rgba(60,64,67,0.302), 0 1px 3px 1px rgba(60,64,67,0.149);
  }

  .search-dropdown {
    border: none !important;
    box-shadow: 0 4px 2px 0 rgba(60,64,67,0.302), 0 4px 3px 1px rgba(60,64,67,0.149);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .search-dropdown-row {
    margin-top: none !important;
    padding: 6px;
    cursor: pointer;
  }

  .search-dropdown-row:hover {
    background: rgb(242, 242, 242);
    padding-left: 12px !important;
    transition: padding-left 0.1s ease-in-out;
  }

  .uk-badge {
    background-image: linear-gradient(to top, #f77062 0%, #fe5196 100%);
  }

  .uk-badge-zero {
    background: rgba(0,0,0,0);
    border: 1px solid #999999;
    color: gray;
  }

  .album-header {
    background: #E4E4E4;
  }

  .albums .uk-active {
      box-shadow: 0 14px 20px -14px rgba(0,0,0,0.35), 0 10px 10px -14px rgba(0,0,0,0.32) !important
  }

  .uk-sticky-fixed {
    margin: 0 0 0 0;  
  }

  @media only screen and (max-width: 680px) {
    .standAloneImg {
      flex-grow: 0;
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }  

  .hr-fade {
    margin: 20px 0 30px 0;
    border: 0;
    height: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);    
  }

  .body-navbar {
    background: #E4E4E4;
    padding-top: 4px;
    padding-bottom: 4px;
    z-index: 1;
  }

  .uk-active {
    box-shadow: 0 2px 7px rgba(0,0,0,0.25);
    transition: box-shadow 0.5s ease-in-out;
  }

  .gallery-nav-button { 
    border-radius: 3px;
      margin-right: 14px;
      background-color: #ffffff;
      text-transform: none;
      color: #5F6368;
      box-shadow: 0 2px 2px 0 rgba(150, 150, 150, 0.14), 0 3px 1px -2px rgba(150, 150, 150, 0.14), 0 1px 5px 0 rgba(150, 150, 150, 0.14);      
  }
  .gallery-nav-button:focus, .gallery-nav-button:hover {
      background-color: #28a5f5;
      color: #fff;
      
  }    

  .uk-dropdown {
    border-radius: 4px;
  }

  .dropdown-list {
    list-style: none;
    padding: 10px 0 10px 0;
    margin: 0px;
  }

  .drop-list-item {
    padding: 8px;
    padding-left: 20px;
    cursor: pointer;
  }

  .drop-list-item:hover {
    background: rgb(242, 242, 242);
    padding-left: 26px;
    transition: padding-left 0.1s ease-in-out;    
  }  

  .active-button {
    box-shadow: 
    inset 0 -3px 0 0 #28a5f5,0 2px 2px 0 rgba(150, 150, 150, 0.14), 0 3px 1px -2px rgba(150, 150, 150, 0.14), 0 1px 5px 0 rgba(150, 150, 150, 0.14);      
    color: #5F6368;
    font-weight: bold;
  }
</style>

<style lang="scss">
 /* Cool loading wave animation */
  .centered {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .box {
    width: 635px;
    height: 143px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    
    .circle {
      width: 25px;
      height: 25px;
      //box-shadow: 0 0 0 1px rgba($color-default, .2) inset;
      border-radius: 50%;
      margin-left: -12px;
      margin-top: -12px;
      position: relative;
      animation: rotate 1s linear infinite;
      
      &:after, &:before {
        position: absolute;
        width: 10px;
        height: 1px;
        content: "";
        border-radius: 50%;
        left: 0;
        right: 0;
        margin: auto;
      }
      
      &:after {
        top: -1px;
        background-color: #28a5f5;
      }
      
      &:before {
        top: 5px;
        background-color: rgba(255, 255, 255, 0.315);
      }
    }
    
    @for $i from 1 through 550 {
      .circle:nth-child(#{$i}) {
        animation-delay: $i * 0.003s;
      }
    }
  }

  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }    
</style>